<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
  }
}
</script>

<style scope>
#app {
  background-color: #3A4861;
  width: 100%;
  font-family: 'Roboto Condensed', sans-serif;
  padding: 0px;
  margin: 0px;
} 



</style>
